import Add from "@mui/icons-material/Add";
import History from "@mui/icons-material/History";
import Language from "@mui/icons-material/Language";
import { Button, ButtonGroup, Link, Popover } from "@mui/material";
import { useState } from "react";

import type { UUID } from "../../utils/uuid";
import type { ButtonProps } from "@mui/material";
import type { FC, MouseEvent } from "react";

interface NewMomentButtonProps extends ButtonProps {
  title?: string;
  discoverHref: string;
  newMomentHref: string;
}

export const NewMomentButton: FC<NewMomentButtonProps> = ({
  title,
  discoverHref,
  newMomentHref,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>): void => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  const buttonStyles = { justifyContent: "flex-start" };

  return (
    <>
      <Button
        data-analytics-id="tabbed-programs-new-moment-button"
        onClick={handleClick}
        color="primary"
        variant="contained"
        {...props}
      >
        {title ?? "New Communication"}
      </Button>
      <Popover
        open={open}
        id={id}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        transformOrigin={{ horizontal: "left", vertical: -5 }}
      >
        <ButtonGroup orientation="vertical">
          <Button
            data-analytics-id="tabbed-programs-new-moment-button-from-scratch"
            variant="contained"
            color="primary"
            LinkComponent={Link}
            href={newMomentHref}
            sx={buttonStyles}
          >
            <Add sx={{ mr: 1 }} />
            From Scratch
          </Button>
          <Button
            data-analytics-id="tabbed-programs-new-moment-button-discover"
            variant="contained"
            color="primary"
            LinkComponent={Link}
            href={discoverHref}
            sx={buttonStyles}
          >
            <Language sx={{ mr: 1 }} />
            Discover a Communication
          </Button>
        </ButtonGroup>
      </Popover>
    </>
  );
};

export const SentMomentsButton: FC<{ programId?: UUID }> = ({ programId }) => (
  <Button
    data-analytics-id="tabbed-programs-sent-moments"
    LinkComponent={Link}
    href={programId !== undefined ? `/moments/history?program=${programId}` : "/moments/history"}
    variant="outlined"
    color="primary"
    sx={{ ml: 2 }}
  >
    <History sx={{ mr: 1 }} />
    Sent Communications
  </Button>
);
